import o from "./ghl-ui.es1506.js";
import u from "./ghl-ui.es1466.js";
function m(r) {
  u(1, arguments);
  var t = o(r), e = t.getHours();
  return e;
}
export {
  m as default
};
